import React, { useEffect, useMemo, useState, useRef } from "react";
import { Formik, Form } from "formik";
import { Table, Button, Spinner, Form as RBForm, InputGroup } from "react-bootstrap";
import { eventService } from "../lib/api/event";
import Swal from "sweetalert2";
import { serverImgUrl } from '../config/constants';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { routes } from "../routes/routes-names";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { organizationService } from "../lib/api/organization";

interface attendanceList {
  attendanceDate: string;
  latitude: string;
  longitude: string;
  photo: string;
}
interface DoctorItem {
  doctorId: number;
  fmrNo: string;
  doctorName: string;
  latitude: string;
  longitude: string;
  createdon: string;
  contactNumber: string;
  email: string;
  attendanceList: attendanceList[];
}
interface BulkStatus {
  status: string;
  totalTasks: number;
  completedTasks: number;
  failedTasks: number;
}
enum BulkJobStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED"
}

const CPDCertificatePrint: React.FC = () => {
  const navigate = useNavigate();
  const [selectedEvent, setSelectedEvent] = useState('');
  const [eventData, setEventData] = useState<any[]>([]);
  const [eventId, setEventId] = useState<any>();
  const [selectedOrg, setSelectedOrg] = useState("");
  const [orgData, setOrgData] = useState<any[]>([]);
  const [orgSearchQuery, setOrgSearchQuery] = useState("");
  const selectedOrgName =
    orgData.find((org) => String(org.id) === String(selectedOrg))?.organizationName || "";

  const [doctordata, setDoctorData] = useState<DoctorItem[]>([]);
  const [selected, setSelected] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightBoxImagePath, setLightBoxImagePath] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(15);

  const [bulkStatus, setBulkStatus] = useState<any | null>(null);
  const [bulkRequestId, setbulkRequestId] = useState('');
  const [contactSearch, setContactSearch] = useState('');
  //const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const filteredOrgData = useMemo(() => {
    const normalizedSearch = orgSearchQuery.trim().toLowerCase();
    if (!normalizedSearch) return orgData;
    return orgData.filter((org) =>
      String(org.organizationName || "").toLowerCase().includes(normalizedSearch)
    );
  }, [orgData, orgSearchQuery]);

  const getProgressPercent = (completed: number, total: number) => {
    if (!total) return 0;
    return Math.round((completed / total) * 100);
  };

  useEffect(() => {

    getAllApprovedOrgs();
  }, []);

  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

useEffect(() => {
  if (!bulkRequestId) return;

  const fetchStatus = async () => {
    try {
      console.log("Polling status...");
      const jobStatus = await eventService.fetchBulkStatus(bulkRequestId);
      setBulkStatus(jobStatus);

      if (
        jobStatus.status === BulkJobStatus.COMPLETED ||
        jobStatus.status === BulkJobStatus.FAILED
      ) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          console.log("Polling stopped");
        }
      }
    } catch (error) {
      console.error("Failed to fetch bulk status", error);
    }
  };

  fetchStatus(); // immediate

  intervalRef.current = setInterval(fetchStatus, 5000);
  console.log("Polling started");

  return () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      console.log("Polling cleaned up");
    }
  };
}, [bulkRequestId]);


  const handleEventChange = (event: any) => {
    setSelectedEvent(event.target.value);
    const eventId = parseInt(event.target.value);
    setEventId(eventId);
  };
  const handleOrgChange = async (event: any) => {
    const orgId = event.target.value;
    setSelectedOrg(orgId);
    //const {success, data } = await eventService.getAllEventsbyOrgid(orgId);
    const { success, data } = await eventService.getEventsbyOrgidAndStatus(orgId, "apr");
    if (success) {
      setEventData(data);
    }
  };
  const getAllApprovedOrgs = async () => {
    try {
      const { data } = await organizationService.getOrganizationDetailsforVerification('apr');
      if (data.length > 0) {
        setOrgData(data);
      }

    } catch {
    }
  };

  const fetchPendingApprovals = async (eventId: any, status: any) => {
    setLoading(true);
    try {
      setSelected([]); // reset previous selections when reloading list
      setDoctorData([]);
      if (eventId && eventId !== undefined && eventId !== null && eventId !== 0) {
        const { success, data } = await eventService.getDoctorDetailsByEventIdStatus(selectedEvent, status);
        if (data.length > 0) {
          setDoctorData(data);
        }
      } else {
        Swal.fire({
          title: "",
          text: "Please select Event Id",
          icon: "warning",
          confirmButtonText: "OK",
        }).then(async (result) => {
        });
      }
    } catch (err) {
      console.error("Error fetching approvals:", err);
    } finally {
      setLoading(false);
    }

  };

  const fetchDoctorsByContactNumber = async (status: any, contactNumber: any) => {
    setLoading(true);
    try {
      setSelected([]); // reset previous selections when searching by contact
      setDoctorData([]);
      if (contactNumber && contactNumber !== undefined && contactNumber !== null && contactNumber !== 0) {
        const { success, data } = await eventService.getDoctorDetailsByApprovalAndContactNumber(status, contactNumber);
        // API sometimes returns a single object instead of an array; normalize to an array
        const list = Array.isArray(data) ? data : data ? [data] : [];
        setDoctorData(list);
        if (!success || list.length === 0) {
          Swal.fire({
            title: "",
            text: "No doctor found for that contact number",
            icon: "info",
            confirmButtonText: "OK",
          });
        }
      } else {
        Swal.fire({
          title: "",
          text: "Please enter Doctor's contact number",
          icon: "warning",
          confirmButtonText: "OK",
        }).then(async (result) => {
        });
      }
    } catch (err) {
      console.error("Error fetching data by contact number:", err);
    } finally {
      setLoading(false);
    }

  };

  const toggleSelect = (id: number) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };


  const selectAll = () => {
    const pageData = paginatedData();
    const pageIds = pageData
      .map((d: any) => d.doctorId ?? d.id)
      .filter((id) => id !== undefined && id !== null);

    const allSelected = pageIds.every((id) => selected.includes(id));

    if (allSelected) {
      setSelected((prev) => prev.filter((id) => !pageIds.includes(id)));
    } else {
      setSelected((prev) => Array.from(new Set([...prev, ...pageIds])));
    }
  };

  const handleDownloadCertificates = async () => {
    if (selected.length === 0) {
      Swal.fire({
        title: "",
        text: "Please select at least one record.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await eventService.downloadCertificates({
        ids: JSON.stringify(selected),
        eventId,
        orgId: selectedOrg,
      });

      const disposition = response.headers?.["content-disposition"];
      const fallbackName = `certificates_${moment().format("YYYYMMDD_HHmmss")}.zip`;
      const match = disposition?.match(/filename\\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/);
      const fileName = decodeURIComponent(match?.[1] || match?.[2] || fallbackName);

      const blob = new Blob([response.data], {
        type: response.headers?.["content-type"] || "application/zip",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        title: "Success",
        text: "Certificates download started.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (err) {
      console.error("Error downloading certificates", err);
      Swal.fire({
        title: "",
        text: "Failed to download certificates. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEmailSend = async () => {
    if (selected.length === 0) {
      Swal.fire({
        title: "",
        text: "Please select at least one record.",
        icon: "warning",
        confirmButtonText: "OK",
      }).then(async (result) => {
      });
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("ids", JSON.stringify(selected));
      formData.append("eventId", eventId);
      formData.append("orgId", selectedOrg);

      const { data, success, message } = await eventService.sendEmailcertificate(formData);

      if (success) {
        setbulkRequestId(data); // START POLLING

        setLoading(false);
        Swal.fire({
          title: "success",
          text: message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(async (result) => {
        });

      } else {
        setLoading(false);
        Swal.fire({
          title: "",
          text: message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(async (result) => {
        });
      }
      fetchPendingApprovals(eventId, 'apr');
      setSelected([]);
    } catch (err) {
      setLoading(false);
      console.error("Error in Mail Sending", err);
      Swal.fire({
        title: "",
        text: "Mail Sending in progress",
        icon: "success",
        confirmButtonText: "OK",
      }).then(async (result) => {
      });
    }
  };


  const totalPages = Math.ceil(doctordata.length / recordsPerPage);

  const paginatedData = () => {
    const start = (currentPage - 1) * recordsPerPage;
    return doctordata.slice(start, start + recordsPerPage);
  };

  const handleContactSearch = () => {
    setCurrentPage(1);
    fetchDoctorsByContactNumber('apr', contactSearch.trim());
  };

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="container mt-4 cpd-shell">
      <h3 className="mb-3 text-center cme-header">Doctor Certificate Generation</h3>
      <Formik initialValues={{}} onSubmit={() => { }}>
        <Form>
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              <div className="row gy-3 gx-4">
                <div className="col-12 col-lg-6">
                  <label className="form-label fw-semibold">Select Organization Name</label>
                  <RBForm.Control
                    type="text"
                    className="mb-2"
                    placeholder="Filter organization by keyword"
                    value={orgSearchQuery}
                    onChange={(e) => setOrgSearchQuery(e.target.value)}
                  />
                  <select
                    name="organizationType"
                    value={selectedOrg}
                    onChange={handleOrgChange}
                    className="form-select org-name-wrap"
                  >
                    <option value="" disabled>--Please choose an option--</option>
                    {filteredOrgData.map((orgtype) => (
                      <option key={orgtype.id} value={orgtype.id} title={orgtype.organizationName}>
                        {orgtype.organizationName}
                      </option>
                    ))}
                    {filteredOrgData.length === 0 && (
                      <option value="" disabled>No organization found</option>
                    )}
                  </select>
                </div>
                <div className="col-12 col-lg-6">
                  <label className="form-label fw-semibold">Select Event Name</label>
                  <select
                    name="EventType"
                    value={selectedEvent}
                    onChange={handleEventChange}
                    className="form-select"
                  >
                    <option value="" disabled>--Please choose an option--</option>
                    {eventData.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.nameOfEvent}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <hr className="my-3" />

              <div className="row gy-3 gx-3 align-items-center">
                <div className="col-12 col-lg-6">
                  <div className="d-flex flex-wrap gap-2">
                    <Button variant="primary" onClick={() => fetchPendingApprovals(eventId, 'apr')}>
                      Get approved Doctors
                    </Button>
                    <Button variant="secondary" onClick={() => fetchPendingApprovals(eventId, 'rej')}>
                      Get Rejected Doctors
                    </Button>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="d-flex flex-wrap align-items-center gap-3 justify-content-lg-end">
                    <div className="d-flex align-items-center gap-2">
                      <RBForm.Label className="mb-0 fw-semibold text-nowrap">Search Doctor by Contact Number</RBForm.Label>
                      <InputGroup size="sm" className="contact-search" style={{ maxWidth: 260 }}>
                        <RBForm.Control
                          type="text"
                          placeholder="Search by contact number"
                          value={contactSearch}
                          onChange={(e) => setContactSearch(e.target.value)}
                          style={{ paddingRight: 34 }}
                        />
                        <Button
                          variant="link"
                          onClick={handleContactSearch}
                          aria-label="Search by contact number"
                          className="p-0 position-absolute top-50 end-0 translate-middle-y me-2"
                          style={{
                            width: 24,
                            height: 24,
                            minWidth: 24,
                            border: "none",
                            boxShadow: "none",
                            color: "#6c757d"
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                          </svg>
                        </Button>
                      </InputGroup>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                      <Button variant="outline-primary" onClick={handleDownloadCertificates}>
                        Download Certificates
                      </Button>
                      <Button variant="success" onClick={handleEmailSend}>
                        Send Email for Selected
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center flex-wrap gap-3 mb-2 w-100">
            <div className="d-flex align-items-center gap-2">
              <RBForm.Label className="mb-0 fw-semibold">Rows per page</RBForm.Label>
              <RBForm.Select
                size="sm"
                value={recordsPerPage}
                onChange={(e) => {
                  setRecordsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{ width: "auto" }}
              >
                {[10, 15, 25, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </RBForm.Select>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 ms-auto">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                >
                  « First
                </Button>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  ‹ Prev
                </Button>
                <RBForm.Select
                  size="sm"
                  value={currentPage}
                  onChange={(e) => handlePageChange(Number(e.target.value))}
                  style={{ width: "auto" }}
                >
                  {[...Array(totalPages)].map((_, i) => (
                    <option key={i} value={i + 1}>
                      Page {i + 1} of {totalPages}
                    </option>
                  ))}
                </RBForm.Select>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next ›
                </Button>
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  Last »
                </Button>
              </div>
            )}
          </div>

          <div className="table-scroll-x">
            <Table bordered hover responsive className="align-middle doctor-table shadow-sm">
              <thead className="table-primary">
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={selectAll}
                      checked={
                        paginatedData().every((i) => selected.includes(i.doctorId)) &&
                        paginatedData().length > 0
                      }
                    />
                  </th>
                  <th>Doctor Name</th>
                  <th>FMR No</th>
                  <th>Contact Number</th>
                  <th>Email</th>
                  <th>Photo</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData().length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center text-muted">
                      No pending approvals
                    </td>
                  </tr>
                ) : (
                  paginatedData().map((item) => {
                    const rowId = (item as any).doctorId ?? (item as any).id;
                    const attendancePhotos: attendanceList[] = Array.isArray((item as any).attendanceList)
                      ? (item as any).attendanceList
                      : [];
                    return (
                      <tr key={rowId}>
                        <td>
                          <input
                            type="checkbox"
                            checked={rowId ? selected.includes(rowId) : false}
                            onChange={() => rowId && toggleSelect(rowId)}
                          />
                        </td>
                        <td>{item.doctorName}</td>
                        <td>{item.fmrNo}</td>
                        <td>{item.contactNumber}</td>
                        <td>{item.email}</td>
                        <td>
                          <div className="photo-grid">
                            {attendancePhotos.map((photos: attendanceList) => (
                              <div
                                className="photo-card"
                                onClick={() => {
                                  setLightBoxImagePath(photos.photo); setLightboxOpen(true);
                                }}
                                key={photos.photo + photos.attendanceDate}
                              >
                                <p className="photo-date">Date: {photos.attendanceDate}</p>
                                <img
                                  src={serverImgUrl + '/photos/' + photos.photo}
                                  alt="Attendance"
                                  width={90}
                                  height={90}
                                />
                                <p className="photo-coord">Lat, Long</p>
                                <span className="photo-coord-value">
                                  {photos.latitude + "," + photos.longitude}
                                </span>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </Form>
      </Formik>

      <div>
        <Lightbox
          open={lightboxOpen}
          plugins={[Zoom]}
          close={() => setLightboxOpen(false)}
          slides={[
            {
              src: serverImgUrl + '/photos/' + lightBoxImagePath,
              alt: "edu_cert1",
              width: 3840,
              height: 2560,
              srcSet: [
                { src: serverImgUrl + '/photos/' + lightBoxImagePath, width: 100, height: 100 },
              ]
            }
          ]}
        />
      </div>

      {/* show Bulk Email processing status*/}
      {bulkStatus && (
        <div className="mt-4">

          <h5>Certificates Email Status</h5>

          {/* Progress wrapper */}
          <div className="progress mb-3" style={{ height: "22px" }}>
            <div
              className={`progress-bar progress-bar-striped progress-bar-animated ${
                bulkStatus.status === "COMPLETED"
                  ? "bg-success"
                  : bulkStatus.status === "FAILED"
                  ? "bg-danger"
                  : "bg-info"
              }`}
              role="progressbar"
              style={{
                width: `${getProgressPercent(
                  bulkStatus.completedTasks,
                  bulkStatus.totalTasks
                )}%`
              }}
            >
              {getProgressPercent(
                bulkStatus.completedTasks,
                bulkStatus.totalTasks
              )}%
            </div>
          </div>

          {/* Status Table */}
          {/*
          <Table bordered striped hover>
            <thead className="table-dark">
              <tr>
                <th>Status</th>
                <th>Total Certificates</th>
                <th>Completed Certificates</th>
                <th>Failed Certificates</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{bulkStatus.status}</td>
                <td>{bulkStatus.totalTasks}</td>
                <td>{bulkStatus.completedTasks}</td>
                <td>{bulkStatus.failedTasks}</td>
              </tr>
            </tbody>
          </Table>*/}
          {/*
          <small className="text-muted">
            {bulkStatus.completedTasks} / {bulkStatus.totalTasks} completed
          </small>*/}
        </div>
      )}
      
    </div>
  );
};

export default CPDCertificatePrint;
